export const GET_FLUID_LOOKUP = 'GET_FLUID_LOOKUP'
export const GET_FLUID_LOOKUP_SUCCESS = 'GET_FLUID_LOOKUP_SUCCESS'
export const GET_FLUID_LOOKUP_FAILED = 'GET_FLUID_LOOKUP_FAILED'

export const RESET_FLUID_LOOKUP = 'RESET_FLUID_LOOKUP'
